// extracted by mini-css-extract-plugin
export default {"wrapper":"sidebarErrorBoundary_wrapper__USs2t"};